import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { logoutUser } from "../../../redux/user/userslice";
import { useDispatch, useSelector } from "react-redux";

const DashboardHeaderComponent = () => {
    const user = useSelector((state) => state.user);
    const [activeNav, setActiveNav] = useState("");
    const [hoveredTab, setHoveredTab] = useState("");
    const [hoveredDropDown, setHoveredDropDown] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();


    //set Active Link
    const handleActiveNav = (navItem, route) => {
        setActiveNav(navItem);
        navigate(route)
    };

    const handleMouseEnter = (navItem) => {
        setHoveredTab(navItem);
    };

    const handleMouseLeave = () => {
        setHoveredTab("");
    };

    const handleDropDownMouseEnter = (dropdown) => {
        setHoveredDropDown(dropdown)
    };

    const handleDropDownMouseLeave = () => {
        setHoveredDropDown("")
    };

    const logoutClick = () => {
        dispatch(logoutUser());
        localStorage.clear();
        navigate("/");
    };

    return (
        <>
            <div className="wrapper">
                <div className="header-wrapper">
                    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm px-3">
                        {/* Logo */}
                        <a className="navbar-brand d-flex align-items-center" href="/dashboard">
                            <img src="\horizontal\assets\images\logo_img_new.jpg"
                                className="logo-icon" alt="logo"
                                style={{ width: "150px" }}
                            />
                        </a>
                        {/* Toggle button (for mobile view) */}
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar" aria-controls="mainNavbar" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon" />
                        </button>

                        {/* Navbar Links */}
                        <div className="collapse navbar-collapse justify-content-between" id="mainNavbar">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                {/* Dropdown for Dashboard */}
                                <li className="nav-item dropdown me-2"
                                    onMouseEnter={() => handleDropDownMouseEnter("dashboard")}
                                    onMouseLeave={handleDropDownMouseLeave}>
                                    <a
                                        className={`nav-link d-flex align-items-center ${activeNav === "dashboard" ||
                                            hoveredTab === "dashboard" ||
                                            hoveredDropDown === "dashboard"
                                            ? "bg-primary text-white"
                                            : "text-dark"
                                            }`}
                                        href="#"
                                        aria-expanded={hoveredDropDown === "dashboard" ? 'true' : "false"}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setHoveredDropDown("dashboard");
                                        }}
                                    >
                                        <div className="parent-icon me-2">
                                            <i className="bx bx-customize"></i>
                                        </div>
                                        <div className="menu-title">Dashboard</div>
                                    </a>
                                    <ul className={`dropdown-menu ${hoveredDropDown === "dashboard" ? 'show' : ''}`}>
                                        <li>
                                            <a
                                                className={`dropdown-item d-flex align-items-center ${activeNav === "summary" ? "bg-primary text-white" : "text-dark"
                                                    }`}
                                                href="/dashboard/"
                                                onClick={() => handleActiveNav("summary")}
                                            >
                                                <i className="bx bx-right-arrow-alt me-2"></i>
                                                <span>Summary</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className={`dropdown-item d-flex align-items-center ${activeNav === "details" ? "bg-primary text-white" : "text-dark"
                                                    }`}
                                                href="/dashboarddetails"
                                                onClick={() => handleActiveNav("details")}
                                            >
                                                <i className="bx bx-right-arrow-alt me-2"></i>
                                                <span>Details</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item me-2" onMouseEnter={() => handleMouseEnter("leads")} onMouseLeave={handleMouseLeave} >
                                    <a className={`nav-link ${activeNav === "leads" ? "bg-primary text-white" : hoveredTab === "leads" ? 'bg-primary text-white' : 'text-dark'}`} onClick={(e) => {
                                        e.preventDefault();
                                        handleActiveNav("leads", '/leads');
                                    }} aria-current="page"><i className="bx bx-user-check me-2" />Leads</a>
                                </li>
                                <li className="nav-item me-2" onMouseEnter={() => handleMouseEnter("activity")} onMouseLeave={handleMouseLeave} >
                                    <a className={`nav-link ${activeNav === "activity" ? "bg-primary text-white" : hoveredTab === "activity" ? 'bg-primary text-white' : 'text-dark'}`} onClick={(e) => {
                                        e.preventDefault();
                                        handleActiveNav("activity", '/activity');
                                    }}><i className="fadeIn animated bx bx-checkbox-checked me-2" />Activity</a>
                                </li>

                                {/* Dropdown for Customers and Invoices*/}
                                <li className="nav-item dropdown me-2"
                                    onMouseEnter={() => handleDropDownMouseEnter("customers")}
                                    onMouseLeave={handleDropDownMouseLeave}>
                                    <a
                                        className={`nav-link d-flex align-items-center ${activeNav === "customers" || hoveredTab === "customers" || hoveredDropDown === "customers"
                                            ? "bg-primary text-white"
                                            : "text-dark"
                                            }`}
                                        href="#"
                                        aria-expanded={hoveredDropDown === "customers" ? 'true' : "false"}
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <div className="parent-icon me-2">
                                            <i className="bx bx-group"></i>
                                        </div>
                                        <div className="menu-title">Customers</div>                                    </a>
                                    <ul className={`dropdown-menu ${hoveredDropDown === "customers" ? 'show' : ''}`}>
                                        <li>
                                            <a
                                                className={`dropdown-item d-flex align-items-center ${activeNav === "customers" ? "bg-primary text-white" : "text-dark"}`}
                                                href="/customer"
                                                onClick={() => handleActiveNav("customers")}
                                            >
                                                <i className="bx bx-right-arrow-alt me-2"></i>Customers
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className={`dropdown-item d-flex align-items-center${activeNav === "invoices" ? "bg-primary text-white" : "text-dark"
                                                    }`}
                                                href="/invoice"
                                                onClick={() => handleActiveNav("invoices")}
                                            >
                                                <i className="bx bx-right-arrow-alt me-2"></i>
                                                <span>Invoices</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item me-2" onMouseEnter={() => handleMouseEnter("quotes")} onMouseLeave={handleMouseLeave} > <a className={`nav-link ${activeNav === "quotes" ? "bg-primary text-white" : hoveredTab === "quotes" ? 'bg-primary text-white' : 'text-dark'}`} onClick={(e) => {
                                    e.preventDefault();
                                    handleActiveNav("quotes", '/quotes');
                                }}><i className="fadeIn animated bx bx-file-blank me-1" />
                                    Quotes</a>
                                </li>

                                <li className="nav-item me-2" onMouseEnter={() => handleMouseEnter("tenders")} onMouseLeave={handleMouseLeave} > <a className={`nav-link ${activeNav === "tenders" ? "bg-primary text-white" : hoveredTab === "tenders" ? 'bg-primary text-white' : 'text-dark'}`} onClick={(e) => {
                                    e.preventDefault();
                                    handleActiveNav("tenders", '/tenders');
                                }}><i className="fadeIn animated bx bx-task me-1" />Tenders</a>
                                </li>

                                <li className="nav-item me-2" onMouseEnter={() => handleMouseEnter("service")} onMouseLeave={handleMouseLeave} > <a className={`nav-link ${activeNav === "service" ? "bg-primary text-white" : hoveredTab === "service" ? 'bg-primary text-white' : 'text-dark'}`} onClick={(e) => {
                                    e.preventDefault();
                                    handleActiveNav("service", '/service');
                                }}><i className="fadeIn animated bx bx-outline" />Services</a>
                                </li>

                                {/* Search */}
                                <li className="nav-item me-2" onMouseEnter={() => handleMouseEnter("search")} onMouseLeave={handleMouseLeave} >
                                    <a
                                        className={`nav-link ${activeNav === "search" ? "bg-primary text-white" : hoveredTab === "search" ? 'bg-primary text-white' : 'text-dark'}`} onClick={(e) => {
                                            e.preventDefault();
                                            handleActiveNav("search", '/services/search');
                                        }}
                                    >
                                        <i className="bx bx-search me-2"></i>Search
                                    </a>
                                </li>

                                {/* Dropdown for Settings */}
                                <li
                                    className="nav-item dropdown"
                                    onMouseEnter={() => handleDropDownMouseEnter("settings")}
                                    onMouseLeave={handleDropDownMouseLeave}
                                >
                                    <a
                                        className={`nav-link d-flex align-items-center ${activeNav === "settings" ||
                                            hoveredTab === "settings" ||
                                            hoveredDropDown === "settings"
                                            ? "bg-primary text-white"
                                            : "text-dark"
                                            }`}
                                        href="#"
                                        aria-expanded={hoveredDropDown === "settings" ? "true" : "false"}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setHoveredDropDown("settings");
                                        }}

                                    >
                                        <div className="parent-icon me-2">
                                            <i className="fadeIn animated bx bx-cog"></i>
                                        </div>
                                        <div className="menu-title">Settings</div>
                                    </a>
                                    <ul className={`dropdown-menu ${hoveredDropDown === "settings" ? "show" : ""}`}>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/modules" onClick={() => handleActiveNav("modules")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Module</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/company" onClick={() => handleActiveNav("company")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Company</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/userrole" onClick={() => handleActiveNav("userrole")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>User Roles</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/users" onClick={() => handleActiveNav("users")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Users</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/category" onClick={() => handleActiveNav("category")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Categories</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/items" onClick={() => handleActiveNav("items")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Items</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/country" onClick={() => handleActiveNav("country")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Countries</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/state" onClick={() => handleActiveNav("state")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>States</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/statuses" onClick={() => handleActiveNav("statuses")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Statuses</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/taxgroup" onClick={() => handleActiveNav("taxgroup")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Tax Groups</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/leadsources" onClick={() => handleActiveNav("leadsources")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Lead Sources</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/priorities" onClick={() => handleActiveNav("priorities")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Priorities</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item d-flex align-items-center text-dark" href="/probability" onClick={() => handleActiveNav("probability")}>
                                                <i className="bx bx-right-arrow-alt me-2"></i><span>Probability</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div className="d-flex fs-6 user-box align-item-center justify-content-center">
                                <div className="nav-item dropdown">
                                    <a
                                        className="nav-link dropdown-toggle"
                                        href="#"
                                        id="userDropdown"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <i className="bx bx-user me-2 text-primary" />
                                        {user?.firstName ? `${user.firstName} ${user.lastName} (${user.role?.roleName ?? ""})` : ""}
                                    </a>
                                    <ul className="dropdown-menu" aria-labelledby="userDropdown">
                                        <li><a className="dropdown-item" href="/profile "><i className="bx bx-right-arrow-alt me-2"></i>Profile</a></li>
                                        <li><a className="dropdown-item" href="/myteam"><i className="bx bx-right-arrow-alt me-2"></i>My Team</a></li>
                                        <li><a className="dropdown-item" href="/" onClick={logoutClick}><i className="bx bx-right-arrow-alt me-2"></i>Logout</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav >
                </div>
            </div>
        </>
    )
}

export default DashboardHeaderComponent;